import { reverse } from 'named-urls';

import { EntityModules, RegisterEntityModule } from 'core/constants';
import routes from 'core/routes';
import { LinksType } from 'utils/api/types';
import { getEntityTranslation } from 'stores/EntityDetails/utils';
import { findLinkByEntity } from 'utils/api/modules/tasks/tasks.utils';

export const useEntityDisplayValue = (
  module: EntityModules,
  links: LinksType[]
): { path: string; entityLink?: LinksType; singular: string; plural: string; key: string; singularKey: string } => {
  const { singular, plural, key, singularKey } = getEntityTranslation[module];
  const entityLink = findLinkByEntity(links, module);

  const path = reverse(routes.dashboard[module as RegisterEntityModule].details, {
    entityId: entityLink?.instance.uuid || '',
  });

  return { path, entityLink, singular, plural, key, singularKey };
};
